import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import '../index.scss'
import search from '../../../assets/images/Search.svg'
const TemplateFilter = ({ userDetails, getTemplateDetails, deleteSuccess }) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])

	const [error, setError] = useState(false)
	const [filterData, setFilterData] = useState({
		userId: '',
	})

	const handleSubmit = (e) => {
		e.preventDefault()
		buildRequest()
	}
	const handleKeyPress = (evnt) => {
		let charCode = evnt.which ? evnt.which : evnt.keyCode
		if (charCode === 13) handleSubmit(evnt)
	}

	useEffect(() => {
		if (filterData) {
			buildRequest()
		}
	}, [])

	useEffect(() => {
		if (deleteSuccess) {
			buildRequest()
		}
	}, [deleteSuccess])

	const buildRequest = () => {
		const request = {
			requestID: uuidv4(),
			agentCode:
				userDetails && userDetails.agentCode ? userDetails.agentCode : null,
			userId: filterData && filterData.userId ? filterData.userId.trim() : null,
		}
		getTemplateDetails(request)
	}

	return (
		<div className='form-item--text searchField'>
			<div className="search-container-templates d-flex align-items-center">
				<div className="search-input-wrapper d-flex align-items-center ">
					<img src={search} alt="searchIcon" className='search-icon-templates' />
					<InputText
					id='inputWrapper'
					type='text'
					className='search-user-id-container'
					value={filterData.userId}
					placeholder={t('TEMPLATES.SEARCH_USER_ID')}
					autoComplete='off'
					onChange={(e) => {
						setFilterData({
							...filterData,
							userId: e.target.value,
						})
					}}
					onKeyPress={(e) => handleKeyPress(e)}
					/>
					
				</div>
				<button
				type='button'
				className='primary-button btn-template-search d-none d-lg-flex'
				onClick={handleSubmit}
				>
				{t('COMMON.SEARCH')}
				</button>
			</div>
		</div>
	)
}

export default TemplateFilter
